import React from "react";
import {
  ContentSection,
  SectionHeading,
  ErrorMessage as BronsonErrorMessage,
} from "@vwfs-bronson/bronson-react";
import { DocumentUploadFieldArray } from "../../../components/DocumentUpload/DocumentUploadFieldArray";
import { FieldArray, ErrorMessage } from "formik";
import { Output } from "../../../Text";

class DocumentUploadSection extends React.Component<
  DocumentUploadSectionProps
> {
  render() {
    return (
      <ContentSection.ComponentWrapper>
        <SectionHeading level="3" subtitle={this.props.subTitle} smallSpacing className="u-m-none">
          {this.props.title}
        </SectionHeading>
        <p className="u-mb-small">{Output.resolve("pages.heyCar.documentUpload.fileFormatInfo")}</p>
        <form>
          <FieldArray
            name={this.props.fieldName}
            render={(props) => (
              <DocumentUploadFieldArray
                {...props}
                id={`upload-section-${this.props.fieldName}`}
                transactionId={this.props.transactionId}
                maxFiles={this.props.maxFiles}
              />
            )}
          />

          <ErrorMessage
            name={this.props.fieldName}
            render={(message) => (
              <BronsonErrorMessage>{message}</BronsonErrorMessage>
            )}
          />
        </form>
      </ContentSection.ComponentWrapper>
    );
  }
}

type DocumentUploadSectionProps = {
  title: string;
  subTitle: string;
  transactionId: string;
  fieldName: string;
  maxFiles: number;
};

export { DocumentUploadSection };
